import { FC } from "react";
import { useThemeStore } from "../../stores";
import { useResponsive } from "../../hooks";
import SidePanelSelector from "./side-panel-selector";
import useSidePanelPageStore from "./store";

const SidePanel: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const isMobile = useResponsive();
  const component = useSidePanelPageStore((s) => s.component);

  return (
    <div
      style={{
        width: !isMobile ? 352 : 0,
        minWidth: !isMobile ? 352 : 0,
        maxWidth: !isMobile ? 352 : 0,
        overflowX: "hidden",
        height: "100%",
        background: theme.overlay,
      }}
    >
      <SidePanelSelector />
      {component}
    </div>
  );
};

export default SidePanel;
